import { html, css, unsafeCSS, nothing } from 'lit';
import SotbitButton from '../button';
import styles from './button-dropdown.scss?inline';

export default class SotbitButtonDropdown extends SotbitButton {
    static styles = [
        SotbitButton.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = {
        ...SotbitButton.properties,
        flat: { type: Boolean, reflect: true },
        hideRightIcon: { type: Boolean, attribute: 'hide-right-icon' },
    };

    constructor() {
        super();
        this.flat = false;
        this.hideRightIcon = false;
    }

    templateInnerContent() {
        return html` <slot name="icon-left"></slot>
            <slot name="content">${this.value}</slot>
            ${this.hideRightIcon
                ? nothing
                : html`<slot name="icon-right">
                      <sotbit-icon icon="dropdown" size="m" no-padding></sotbit-icon>
                  </slot>`}`;
    }
}
